import React from "react";
import Spaces from "../../../../../components/sharedComponents/Spaces";

export default function(props: any) {
  
  return(<section className={"text--center"}>
    L'entreprise n'a actuellement aucun poste ouvert
    <Spaces n={3}/>
  </section>);
}